import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Snackbar from '@mui/material/Snackbar'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react-lite'
import { newVersionStore } from './NewVersionStore'

export const RELOAD_BLOCKED_MESSAGE = 'Reload after your recording ends.'

/** Reload button that stays disabled while a recording would be lost. */
export const NewVersionReloadButton = observer(function NewVersionReloadButton() {
   return <Button
      variant='contained'
      size='small'
      disabled={newVersionStore.isRecordingLive}
      onClick={newVersionStore.reload}
   >
      Reload
   </Button>
})

/** Non-blocking banner offering a reload onto a newly deployed frontend. */
export const NewVersionBanner = observer(function NewVersionBanner() {
   return <Snackbar open={newVersionStore.isBannerVisible} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert
         severity='info'
         variant='outlined'
         onClose={newVersionStore.dismiss}
         action={<NewVersionReloadButton />}
         sx={{ backgroundColor: 'background.paper', alignItems: 'center' }}
      >
         <Stack>
            <Typography variant='body2'>A new version of the app is available.</Typography>
            {newVersionStore.isRecordingLive && <Typography variant='caption'>{RELOAD_BLOCKED_MESSAGE}</Typography>}
         </Stack>
      </Alert>
   </Snackbar>
})

/** Stands in for a section whose code could not be loaded because a newer version replaced it. */
export const NewVersionPlaceholder = observer(function NewVersionPlaceholder() {
   return <Stack spacing={1} alignItems='flex-start' sx={{ padding: 3 }}>
      <Typography variant='body1'>This part of the app has been updated since you opened it.</Typography>
      <Typography variant='body2'>
         {newVersionStore.isRecordingLive ? RELOAD_BLOCKED_MESSAGE : 'Reload to load the new version.'}
      </Typography>
      <NewVersionReloadButton />
   </Stack>
})
